// FirestoreEventsList.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import EventCard from '../components/EventCard';

const EventsList = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);





    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.scroll-reveal').forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    // Fetch events from the "events" collection
    useEffect(() => {
        async function fetchEvents() {
            try {
                const eventsCollection = collection(db, 'events');
                const querySnapshot = await getDocs(eventsCollection);
                const eventsData = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setEvents(eventsData);
            } catch (err) {
                console.error('Error fetching events:', err);
                setError('Failed to load events.');
            } finally {
                setLoading(false);
            }
        }
        fetchEvents();
    }, []);

    if (loading) {
        return <p>Loading events...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }



    return (
        <div className='outer-event-container'>

            <div className="event-container">
                {events.length > 0 ? (
                    events.map((event, index) => (
                        <EventCard key={event.id} event={event} index={index} />
                    ))
                ) : (
                    <p>No events found.</p>
                )}
            </div>

        </div>
    );
};

export default EventsList;
